import { render, staticRenderFns } from "./SystemMessageCard.vue?vue&type=template&id=e52f63d0&scoped=true&lang=pug&"
import script from "./SystemMessageCard.vue?vue&type=script&lang=ts&"
export * from "./SystemMessageCard.vue?vue&type=script&lang=ts&"
import style0 from "./SystemMessageCard.vue?vue&type=style&index=0&id=e52f63d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52f63d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
